import { formatDate, convertInString } from "@/utils/formatting";

export default {
  state: {
    patient: {},
    updatePatient: false,
    routeName: "",
  },

  getters: {
    getPatientData(state) {
      return state.patient;
    },

    getPatientCrudType(state) {
      return state.updatePatient;
    },

    getRouteName(state){
      return state.routeName
    },
  },

  mutations: {
    setPatientData(state, data) {
      const isUpdate = Object.keys(data).length > 0;

      state.patient = {
        codigo: isUpdate ? data.codigo : "",
        prontuario: isUpdate ? data.prontuario : "",

        cpf: isUpdate ? data.cpf : "",
        nroCartaoSaude: isUpdate ? data.nroCartaoSaude : "",

        nome: isUpdate ? data.nome : "",
        nomeSocial: isUpdate ? data.nomeSocial : "",
        codigoSexo: isUpdate ? convertInString(data.codigoSexo) : "",
        codigoCor: isUpdate ? convertInString(data.codigoCor) : "",
        codigoEstadoCivil: isUpdate
          ? convertInString(data.codigoEstadoCivil)
          : "",
        nomeMae: isUpdate ? data.nomeMae : "",
        nomePai: isUpdate ? data.nomePai : "",
        dataNascimento: isUpdate ? formatDate(data.dataNascimento) : "",
        codigoNacionalidade: isUpdate
          ? convertInString(data.codigoNacionalidade)
          : "",
        codigoNaturalidade: isUpdate ? data.codigoNaturalidade : "",
        codigoGrauInstrucao: isUpdate
          ? convertInString(data.codigoGrauInstrucao)
          : "",
        codigoOcupacao: isUpdate ? data.codigoOcupacao : "",

        email: isUpdate ? data.email : "",
        dddFoneResidencial: isUpdate ? data.dddFoneResidencial : "",
        foneResidencial: isUpdate ? data.foneResidencial : "",
        dddFoneRecado: isUpdate ? data.dddFoneRecado : "",
        foneRecado: isUpdate ? data.foneRecado : "",
        dddFoneCelular: isUpdate ? data.dddFoneCelular : "",
        foneCelular: isUpdate ? data.foneCelular : "",

        dataEntradaBrasil: isUpdate ? formatDate(data.dataEntradaBrasil) : "",
        dataNaturalizacao: isUpdate ? formatDate(data.dataNaturalizacao) : "",
        portariaNatural: isUpdate ? data.portariaNatural : "",

        enderecos: isUpdate ? data.enderecos : [],
        nroIdentidade: isUpdate ? data.nroIdentidade : "",
        codigoOrgaoEmissor: isUpdate ? data.codigoOrgaoEmissor : "",
        siglaUfIdentidade: isUpdate ? data.ufIdentidade : "",
        dataEmissaoIdentidade: isUpdate
          ? formatDate(data.dataEmissaoIdentidade)
          : "",
        nroCartaoSaudeMae: isUpdate ? data.nroCartaoSaudeMae : "",
        documentosApresentados: isUpdate ? data.documentosApresentados : false,

        codigoTipoCertidao: isUpdate
          ? convertInString(data.codigoTipoCertidao)
          : "",
        dataEmissaoCertidao: isUpdate
          ? formatDate(data.dataEmissaoCertidao)
          : "",
        nroRegistroCertidao: isUpdate ? data.nroRegistroCertidao : "",
        nomeCartorio: isUpdate ? data.nomeCartorio : "",
        livro: isUpdate ? data.livro : "",
        folhas: isUpdate ? data.folhas : "",
        termo: isUpdate ? data.termo : "",
        numeroDn: isUpdate ? data.numeroDn : "",

        observacao: isUpdate ? data.observacao : "",
      };

      state.updatePatient = isUpdate;
    },
    setRouteName(state, newRoute) {
      state.routeName = newRoute;
    },
  },

  actions: {
    changePatientData(context, data) {
      context.commit("setPatientData", data);
    },

    updateRouteName({ commit }, newRoute) {
      commit("setRouteName", newRoute);
    },
  },
};
